module.exports = __webpack_public_path__ + "static/media/double_arrow.da16a7f9.svg";